<template>
  <div class="box">
    <div class="field is-grouped">
      <div class="control">
        <button type="button" class="button is-danger" @click="goToDashboard()">Back to Dashboard</button>
      </div>
    </div>
    <h3 class="title is-3">Remaining Tickets</h3>
    <div class="field" v-for="(event_row, index) in event_list" :key="index">
      <label class="label" v-text="event_row.title + ' (Start tickets: ' + event_row.start_tickets + ')'"></label>
      <div class="control">
        <money :class="{'input': true}" v-model="event_list[index].tickets" v-bind="number_format"></money>
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button type="button" class="button is-link" @click="submitData()">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import {Money} from 'v-money'
export default {
  data () {
    return {
      selected_service: '',
      selected_counter: '',
      event_list: [],
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  components: {
    Money
  },
  created () {
    this.selected_service = this.getSessionItem('selected_service')
    this.selected_counter = this.getSessionItem('selected_counter')

    this.getEventComplimentaryList()
  },
  methods: {
    goToDashboard () {
      this.$router.push('/panel/frontdesk/dashboard')
    },
    getEventComplimentaryList () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('frontdesk/get_event_complimentary', {
        service: this.selected_service,
        counter: this.selected_counter
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.event_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      var errorFlag = 0
      for (var index in this.event_list) {
        if (this.event_list[index].start_tickets < this.event_list[index].tickets) {
          errorFlag = 1
        }
      }

      if (errorFlag === 1) {
        self.$geb.emit({id: 'preloader', eventData: false})
        self.$geb.emit({id: 'alert_modal', title: 'The tickets must not greater than start tickets', content: 'Please check your input again.', button_text: 'OK'})
      } else {
        self.flyPostSession('frontdesk/submit_event_complimentary', {
          service: this.selected_service,
          counter: this.selected_counter,
          event_list: this.event_list
        })
        .then(function (response) {
          self.$geb.emit({id: 'preloader', eventData: false})
          if (response.data.response_code === 1) {
            self.$geb.emit({id: 'alert_modal', title: 'Submit Event Complimentary Success', content: 'Submit Event Complimentary Success', button_text: 'OK'})
            self.$router.push('/panel/frontdesk/dashboard')
          } else {
            var result = response.data.message
            self.errors.clear()
            for (var name in response.data.message) {
              self.errors.add(name, result[name])
            }
          }
        })
        .catch(function (response) {
          self.$geb.emit({id: 'preloader', eventData: false})
          self.errorMessage(response)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/EventComplimentary.vue